import React from 'react';
import { Container, Row, Col, Button, Image } from 'react-bootstrap';
import heroImage from '../images/mockup_reka.png';
import { AnalyticsHandle } from '../components/AnalyticsHandle';

function FeaturesHero() {
    const { logRegisterClick } = AnalyticsHandle();

    const handleRegisterClick = () => {
        logRegisterClick('features_hero_primary');
        window.open('/register', '_self');
    };

    return (
        <Container className='features-hero' style={{
            paddingTop: '80px',
            paddingBottom: '80px',
            minHeight: '90%',
            borderRadius: '32px'
        }}>
            <Row className='align-items-center'>
                <Col xs={12} md={6} className='text-start mb-5 mb-md-0 features-hero-col' style={{paddingLeft: '50px' }}>
                    {/* Badge */}
                    <div style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '8px',
                        backgroundColor: '#EEF3FF',
                        padding: '8px 16px',
                        borderRadius: '24px',
                        marginBottom: '24px',
                        border: '1px solid #C7D9FF'
                    }}>
                        <span style={{
                            fontSize: '14px',
                            fontWeight: '600',
                            color: '#407EF9'
                        }}>
                            ✨ Funkcjonalności systemu
                        </span>
                    </div>

                    <h1 style={{
                        fontSize: 'clamp(2.5rem, 5vw, 3.5rem)',
                        fontWeight: '800',
                        color: '#1f2937',
                        marginBottom: '24px',
                        lineHeight: '1.15',
                        letterSpacing: '-0.02em',
                        textAlign: 'left'
                    }}>
                        System dopasowany do <span style={{ color: '#407EF9' }}>sposobu pracy</span> Twojego zespołu
                    </h1>

                    <p style={{
                        fontSize: 'clamp(1.1rem, 2vw, 1.25rem)',
                        color: '#4b5563',
                        lineHeight: '1.6',
                        marginBottom: '32px',
                        fontWeight: '500',
                        textAlign: 'left',
                        maxWidth: '550px'
                    }}>
                        Wybierz metodę rejestracji czasu, która najlepiej pasuje do charakterystyki i zaufania w Twojej firmie. Od prostego deklarowania godzin po pełną kontrolę ze start/stop i GPS.
                    </p>

                    {/* Mobile image */}
                    <Row className="d-md-none text-center py-3 mb-4">
                        <Col>
                            <Image
                                style={{
                                    width: "400px",
                                    borderRadius: '20px',
                                    boxShadow: '0 20px 40px rgba(64, 126, 249, 0.25)'
                                }}
                                fluid
                                src={heroImage}
                                alt="Aplikacja eGodziny"
                                className="mobile-hero-image"
                            />
                        </Col>
                    </Row>

                    {/* CTA Buttons */}
                    <div className="d-flex gap-3 justify-content-start flex-wrap features-hero-buttons" style={{ marginTop: '40px' }}>
                        <Button
                            onClick={handleRegisterClick}
                            style={{
                                backgroundColor: '#407EF9',
                                color: 'white',
                                border: 'none',
                                borderRadius: '12px',
                                padding: '16px 32px',
                                fontSize: '1.1rem',
                                fontWeight: '600',
                                transition: 'all 0.3s ease',
                                boxShadow: '0 4px 14px rgba(64, 126, 249, 0.3)'
                            }}
                            onMouseEnter={(e) => {
                                e.target.style.transform = 'translateY(-2px)';
                                e.target.style.boxShadow = '0 6px 20px rgba(64, 126, 249, 0.4)';
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.transform = 'translateY(0)';
                                e.target.style.boxShadow = '0 4px 14px rgba(64, 126, 249, 0.3)';
                            }}
                        >
                            Wypróbuj za darmo
                        </Button>

                        <Button
                            onClick={() => window.open('https://calendly.com/krzysztof-warda-egodziny/30min', '_blank')}
                            style={{
                                backgroundColor: 'white',
                                color: '#1f2937',
                                border: '2px solid #e5e7eb',
                                borderRadius: '12px',
                                padding: '16px 32px',
                                fontSize: '1.1rem',
                                fontWeight: '600',
                                transition: 'all 0.3s ease'
                            }}
                            onMouseEnter={(e) => {
                                e.target.style.transform = 'translateY(-2px)';
                                e.target.style.borderColor = '#407EF9';
                                e.target.style.color = '#407EF9';
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.transform = 'translateY(0)';
                                e.target.style.borderColor = '#e5e7eb';
                                e.target.style.color = '#1f2937';
                            }}
                        >
                            Umów bezpłatne demo
                        </Button>
                    </div>
                </Col>

                <Col xs={12} md={6} className='d-none d-md-flex justify-content-center'>
                    <Image
                        src={heroImage}
                        alt="Osoba korzystająca z eGodziny na telefonie"
                        fluid
                        style={{
                            maxHeight: '600px',
                            width: 'auto',
                            borderRadius: '20px',
                            boxShadow: '0 20px 40px rgba(64, 126, 249, 0.25)'
                        }}
                    />
                </Col>
            </Row>
        </Container>
    );
}

export default FeaturesHero;
